'use strict';

import EaFields from './eaFields.js';
import template from '../../templates/settings/PayrollItemModal.ejs';
import overtimeTemplate from
    '../../templates/settings/OvertimePayrollItemModal.ejs';
import ModalFormView from 'commons/views/ModalForm';

module.exports = ModalFormView.extend({
    events: function() {
        var parentEvents = _.isFunction(ModalFormView.prototype.events) ?
            ModalFormView.prototype.events() :
            ModalFormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'change .js-ext.js-ext-eaField': 'updateEaField'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            showReliefOptions: false
        });
        const applicableEaFields = Object.keys(EaFields)
            .reduce((rs, field) => {
                if (
                    this.options.showReliefOptions ||
                    !['relief', 'zakatRelief'].includes(field)
                ) {
                    return Object.assign(rs, {[field]: EaFields[field]});
                }
                return rs;
            }, {});
        this.options.templateExtra = {eaFields: applicableEaFields};

        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        var r = ModalFormView.prototype.bindHandlers.apply(this, arguments);

        this.model.on('change:affectsMtd', this.toggleMtdLimit, this);
        this.model.on('change:affectsMtd', this.toggleEaField, this);
        this.model.on('change:mtdLimit', this.toggleEaField, this);

        return r;
    },

    unbindHandlers: function() {
        var r = ModalFormView.prototype.bindHandlers.apply(this, arguments);
        this.model.off(null, null, this);
        return r;
    },

    toggleMtdLimit: function() {
        this.$('[name=mtdLimit]')
            .removeAttr('disabled')
            .prop({disabled: !this.model.get('affectsMtd')})
            .focus().select();

        if (!this.model.get('affectsMtd')) {
            this.model.set('mtdLimit', 0);
        }

        return this;
    },

    toggleEaField: function() {
        this.$('[name=taxExemptEaField]')
            .closest('.form-group')
            .toggleClass('hidden', !(
                this.model.get('affectsMtd') &&
                this.model.get('mtdLimit') > 0
            ));
        this.$('.form-group:not(.hidden) [name=taxExemptEaField]')
            .prop('disabled', false).attr('disabled', false);
        this.$('.form-group.hidden [name=taxExemptEaField]')
            .prop('disabled', true).attr('disabled', true);
        this.updateEaField();
    },

    updateEaField: function() {
        let eaFields = [];
        let eaField = this.$('[name=eaField]').val();
        let taxExemptEaField = this.$('[name=taxExemptEaField]').val();
        let limit;
        let offset;

        if (!this.model.get('affectsMtd') || this.model.get('mtdLimit') <= 0) {
            if (eaField) {
                this.model.set('eaFields', [eaField]);
            } else {
                this.model.set('eaFields', null);
            }
            return;
        }

        limit = offset = this.model.get('mtdLimit');
        if (eaField) {
            eaFields.push({field: eaField, offset: offset});
        }
        if (taxExemptEaField) {
            eaFields.push({field: taxExemptEaField, limit: limit});
        }
        this.model.set('eaFields', eaFields);
    },

    render: function() {
        if (this.model.get('type') === 'overtime') {
            this.options.template = overtimeTemplate;
        } else {
            this.options.template = template;
        }

        let returnValue = ModalFormView.prototype.render.apply(this, arguments);
        if (this.model.get('category')) {
            this.$('[name="category"]').val(this.model.get('category'));
        }
        return returnValue;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PayrollItemModal.js